import { Component, Input, HostListener, OnInit, OnDestroy, ViewEncapsulation } from '@angular/core';
import { animate, state, style, transition, trigger, AnimationEvent } from '@angular/animations';

import { Subject } from 'rxjs';
import { tap, takeUntil } from 'rxjs/operators';

import { AppConstants } from '@apps/app.constants';

import { PopinModalRef } from '../popin-modal/popin-modal.ref';

@Component({
    selector: 'aa-popin-v3',
    templateUrl: './popin-v3.component.html',
    styleUrls: [
        './popin-v3.component.scss'
    ],
    animations: [
        trigger('showHide', [
            state('show', style({
                transform: 'translateX(-100%)'
            })),
            state('hide', style({
                transform: 'translateX(100%)'
            })),
            transition('show => hide', [
                animate('1s cubic-bezier(0.35, 0, 0.25, 1)')
            ]),
            transition('hide => show', [
                animate('1s cubic-bezier(0.35, 0, 0.25, 1)')
            ])
        ])
    ],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class PopinV3Component implements OnInit, OnDestroy
{
    @Input() width: number;
    @Input() isShown: boolean = false;
    @Input() onClose: () => void;
    @Input() backPic: 'zen' | 'filter' | 'details' | 'forms' = 'filter';
    @Input() title: string = '';
    @Input() hasCancelButton = false;
    @Input() noTitlePadding = false;
    private destroyator = new Subject();
    public internalBackPic: string;

    constructor (private popinModalRef: PopinModalRef)
    {
    }

    ngOnInit (): void
    {
        this.popinModalRef.overlayRef
            .backdropClick()
            .pipe(
                tap(() =>
                    this.closePopin()
                ),
                takeUntil(this.destroyator)
            )
            .subscribe();

        if (['filter', 'zen'].includes(this.backPic))
        {
            this.internalBackPic = `${this.backPic}${this.getRandomInt()}`;
        }
        else
        {
            this.internalBackPic = this.backPic;
        }
    }

    ngOnDestroy ()
    {
        this.destroyator.next(null);
        this.destroyator.complete();
    }

    @HostListener('window:keydown', ['$event'])
    handleKeyDown (event: KeyboardEvent)
    {
        if (event.key === 'Escape' && this.isShown)
        {
            this.closePopin();
        }
    }

    public onShowHide (event: AnimationEvent)
    {
        const { phaseName, fromState, toState } = event;

        if (fromState === 'show' && toState === 'hide' && phaseName === 'done')
        {
            this.popinModalRef.destroy(true);
        }
    }

    public calcRight ()
    {
        return (-1 * this.width);
    }

    public closePopin (): void
    {
        this.onClose();
    }

    /**
     * Renvoie un nombre entier aléatoire entre 1 et 2
     */
    private getRandomInt (): number
    {
        return Math.floor(Math.random() * Math.floor(AppConstants.QSSearchTop)) % 2 + 1;
    }
}
